import { createContext } from 'react'
import type { ClientTabField } from './clientTabStatus'

export interface ClientTabRequirements {
  formIsLoaded: boolean
  zohoIsInValid: boolean
  isValidZohoId: boolean
  missingIdentityCount: number
  missingAddressCount: number
  filledConsumption: number
  showConsumption: boolean
  missingFields: ReadonlySet<ClientTabField>
}

export const ClientTabRequirementsContext = createContext<ClientTabRequirements>({
  formIsLoaded: false,
  zohoIsInValid: false,
  isValidZohoId: false,
  missingIdentityCount: 0,
  missingAddressCount: 0,
  filledConsumption: 0,
  showConsumption: false,
  missingFields: new Set(),
})
